import {
    getGraphqlFragment,
    GuestProfile,
    MatchedGuestProfilesByIdResultQuery,
    Membership,
    NextMatchedGuestProfilesResultQuery,
} from '@mews-commander/guest-profile';
import { LoyaltyProgramFieldsFragment } from '../../common';
import { LoyaltyMembershipBasicFieldsFragment } from '../components/common';
import {
    GuestProfileAdditionalFieldsFragment,
    GuestProfileBasicFieldsFragment,
    GuestProfileFieldsFragment,
} from '../fragments/guestProfileFragment';

type MatchedGuestProfilesByIdProfiles = MatchedGuestProfilesByIdResultQuery['matchedGuestProfilesById']['profiles'];

type NextMatchedGuestProfilesByIdProfiles = NonNullable<
    NextMatchedGuestProfilesResultQuery['nextMatchedGuestProfiles']
>['profiles'];

export const transformGuestProfiles = (
    profiles: MatchedGuestProfilesByIdProfiles | NextMatchedGuestProfilesByIdProfiles
): GuestProfile[] =>
    profiles.map((profile) => {
        const GuestProfileFields = getGraphqlFragment(GuestProfileFieldsFragment, profile);
        const guestProfileBasicFields = getGraphqlFragment(GuestProfileBasicFieldsFragment, GuestProfileFields);
        const guestProfileAdditionalFields = getGraphqlFragment(
            GuestProfileAdditionalFieldsFragment,
            GuestProfileFields
        );

        let loyaltyMembership: Membership | null = null;

        const membership = getGraphqlFragment(
            LoyaltyMembershipBasicFieldsFragment,
            guestProfileAdditionalFields.loyaltyMembership
        );

        if (membership) {
            const program = getGraphqlFragment(LoyaltyProgramFieldsFragment, membership.program);

            loyaltyMembership = {
                ...membership,
                program: { ...program },
            } satisfies Membership;
        }

        return {
            ...guestProfileBasicFields,
            ...guestProfileAdditionalFields,
            loyaltyMembership,
        } satisfies GuestProfile;
    });
